<template>
    <div>
      <h2>홈화면</h2>
      <p id="home">
        Tens에듀의 <span class="bg-yellow-13">강력한 장점</span>은 <span class="bg-light-green-13">홈화면에서 학생의 모든 것을 관리</span>할 수 있다는 점입니다. <br/>
        즉, 전체 기능을 한눈에 볼 수 있고, <span class="bg-light-green-13">UI가 직관적</span>이어서, 매뉴얼을 일일이 찾아보지 않고도, 어떻게 써야할지를 예상할 수 있을 정도로 편리합니다.
      </p>
      <div><img src="@/assets/aca/manual/home/home.jpg" /></div>
      <p></p>

      <p id="home_parts">
        홈화면의 전체 구조를 간략하게 알아보겠습니다</p>
      <div><img src="@/assets/aca/manual/home/home_block.jpg" /></div>
      <p></p>
      <section>
        <div class="p-relative section_0">
            1)  학생검색 – 전화번호, 반, 교사 등으로 학생 검색
        </div>
        <div class="p-relative section_0">
            2)  학생정보 – 부모님 전화번호, 주소, 학교, 학년, 입학일, 재원상태, 메모 등
        </div>
        <div class="p-relative section_0">
              <div class="p-absolute" style="top:-20px; left:550px"><img src="@/assets/aca/manual/home/home_class_info.jpg" /></div>
            3)  학생수업정보 – <br/>
                학생이 수강하고 있는 반 정보<br/>
                반이름에 마우스를 놓으면 반에 대한 수강료, 담임, 수업일, 과목, 교재 등 나타남.<br/>
        </div>
        <div class="p-relative section_0">
            4)  수강버튼 <br/>
            <div><img src="@/assets/aca/manual/home/home_button.jpg" /></div>
        </div>
        <div class="p-relative section_0">
            5)  결제/상담/출결/보강/문자 – 학생의 모든 이력을 보여줌<br/>
        </div>
        <div class="p-relative section_0">
            6)  오늘 정보<br/>
                - 오늘 날짜의 수업반을 시간별로 보여줌 <br/>
                  &nbsp;&nbsp;반에서 일괄적으로 출결체크가 가능함.<br/>
                - 오늘 보강할 학생을 보여줌<br/>
                - 오늘 수납한 내역을 보여줌<br/>
            <div class="p-absolute" style="top:0px; left:550px"><img src="@/assets/aca/manual/home/home_today.jpg" /></div>
        </div>
      </section>

      <q-drawer show-if-above side="right" class="bg-white">
          <q-list>
            <q-item-label header style="padding:40px 42px 20px;">바로가기</q-item-label>
            <li class="q-px-lg pointer" 
                      v-for="m in menuItems" 
                      :key="m.label"
                      @click="goTo(m.link)" >
                {{m.label}}
            </li>
            
          </q-list>
      </q-drawer>
    </div>
</template>

<script>
import goto from "./goto.js";
export default {
    components : {
    },
    data : function() {
        return {
            menuItems: [
                { label: '홈화면', link: '#home' },
                { label: '홈화면 구조', link: '#home_parts' },
            ]
        }
    },
    computed :{
    },
    methods : {
        goTo(link) {
            goto.goto_link(link);
        }
    },
    beforeMount() {
        goto.clear();
    }
}
</script>


